<template>
  <div class="contact-form__coupon-wrapper">
    <button
      v-if="!showCouponInput"
      class="btn link"
      @click.prevent="showCouponInput = !showCouponInput"
    >
      {{ texts.haveCoupon }}
    </button>
    <transition name="contact-form__fade">
      <form-input
        v-if="showCouponInput"
        ref="coupon"
        v-model="couponModel"
        :label="texts.coupon"
        name="coupon"
        type="text"
        skip-validation-on-blur
        @blur="checkCoupon"
        @trigger-field-error="triggerFieldError"
      />
    </transition>

    <transition name="lavendla-contact-form__reveal-coupon-applied">
      <div v-if="validCoupon && coupon !== ''" class="contact-form__info">
        <p class="valid">&check; {{ texts.couponApplied }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
import FormInput from 'Components/FormInput.vue';

export default {
  name: 'CouponCode',

  components: {
    FormInput,
  },

  props: {
    coupon: {
      type: String,
      default: '',
    },
    validCoupon: {
      type: Boolean,
      default: false,
    },
    checkCoupon: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      showCouponInput: false,
      texts: theme_vars.contactTexts,
    };
  },

  computed: {
    couponModel: {
      get() {
        return this.coupon;
      },
      set(newCoupon) {
        this.$emit('update:coupon', newCoupon);
      },
    },
  },

  methods: {
    triggerFieldError() {
      this.$emit('trigger-field-error');
    },
  },
};
</script>
